// extracted by mini-css-extract-plugin
export default {"root":"_2AjPX","xs":"s8Z5p","sm":"_2kMvm","md":"_23333","lg":"_25Vwi"};